import { render, staticRenderFns } from "./services-config.vue?vue&type=template&id=78ee2a76"
import script from "./services-config.vue?vue&type=script&lang=js"
export * from "./services-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports